import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import { Consulting } from '@layouts/Consulting';
import { Header, Concept, FCQCaseStudy, HowItWorks } from './components';
import { Awards, DescriptionWithImage, Reviews, WeWorkWith } from '@components';
import { weWorkWithData } from '@store/UIUXData';

import appsForControllers from '@static/images/figures/apps-for-controllers.webp';
import useReviewsQuery from '@utils/hooks/useReviewsQuery';

export const Design: React.FC = () => {
	const { directus } = useStaticQuery(graphql`
		query DesignReviews {
			directus {
				PageReviews(filter: { pageName: { _contains: "design" } }) {
					Reviews {
						Reviews_id {
							quote
							reviewerName
							reviewerPosition
							link
							title
							logo {
								id
								imageFile {
									extension
									publicURL
									childImageSharp {
										gatsbyImageData
									}
								}
							}
						}
					}
				}
			}
		}
	`);
	const reviews = useReviewsQuery(directus);

	return (
		<div className="z-99 relative overflow-hidden">
			<Header />
			<Concept />
			<HowItWorks />
			<FCQCaseStudy />
			<DescriptionWithImage image={appsForControllers}>
				<p className="font-size-small-title mb-3 font-600">
					Apps for controllers and residents
				</p>
				<div className="font-size-sm">
					<p className="mb-4">
						We built two multifunctional mobile applications - designed for
						quality controllers and for residents. The former one displays
						information not only about the quality but also the quantity of
						materials.
					</p>
					<p>
						The latter one presents the waste sorting results together with the
						statistics. It also has educational functionalities like materials
						search.
					</p>
				</div>
			</DescriptionWithImage>
			<WeWorkWith data={weWorkWithData} />
			{!!reviews.length && (
				<Reviews
					title="Our client says"
					reviews={reviews}
					maxWidth="1300px"
					titleClass="font-size-medium"
				/>
			)}
			<Awards />
			<Consulting />
		</div>
	);
};
